/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');
require('./promise-7.0.4.min.js');
require('./common/sidebar.js');
require('./common/common.js');
require('./common/customBootstrap.js')
require('./common/page.js')
